import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IControls } from 'bi-interfaces';
import { BIModulesService } from '../bi-modules.service';

@Component({
  selector: 'validation-error-tool-tip',
  templateUrl: './validation-error-tool-tip.component.html',
  styleUrls: ['./validation-error-tool-tip.component.scss']
})
export class ValidationErrorToolTipComponent {
  @Input() Control!: IControls
  @Input() FormControl!: FormControl
  @Input() ControlType!: string
  @Input() LookupIncorrectErrorMsg!: string
  constructor(private translateService: TranslateService, public biService: BIModulesService,
  ) {
    this.biService.getDir()
  }
  getErrorMessage(FormControl: any) {
    const displayName = this.translateService.instant(this.Control.DisplayName);
    if (FormControl && FormControl.invalid) {
      switch (true) {
        case FormControl.errors?.['required']!=null:
          return null;
        case FormControl.errors?.['email']!=null:
          return 'Emailaddressisinvalid';
        case FormControl.errors?.['pattern']!=null:
          return `${displayName} ${this.translateService.instant('inputIsNotInACorrectFormat')}`;
        case FormControl.errors?.['noWhiteSpace']!=null && (!FormControl.errors?.['pattern']!=null):
          return `${displayName} ${this.translateService.instant('cantBeEmpty')}`;
        case FormControl.errors?.['max']!=null:
          return `${displayName} ${this.translateService.instant('maxValueIs')} ${FormControl.errors['max']['max']}`;
        case FormControl.errors?.['min']!=null:
          return `${displayName} ${this.translateService.instant('minValueIs')} ${FormControl.errors['min']['min']}`;
        case FormControl.errors?.['maxlength']!=null:
          return `${displayName} ${this.translateService.instant('maxLenghtIs')} ${FormControl.errors['maxlength']['requiredLength']}`;
        case !FormControl.errors?.['required']!=null && FormControl.errors?.['whitespace']!=null:
          return `${displayName} ${this.translateService.instant('PleaseEnterValidData')}`;
        case FormControl.errors?.['mask']!=null:
          return `Invalid ${displayName} ${this.translateService.instant('Length')}`;
        case FormControl.errors?.['incorrect']!=null:
          return this.LookupIncorrectErrorMsg;
        case FormControl.errors?.['PasswordTooWeak']!=null:
          return `${displayName} : ${this.translateService.instant('PasswordTooWeak')}`;
        case FormControl.errors?.['MedumPasswordError']!=null:
          return `${displayName} : ${this.translateService.instant('MedumPasswordError')}`;
        case FormControl.errors?.['ComplexPasswordError']!=null:
          return `${displayName} : ${this.translateService.instant('ComplexPasswordError')}`;
        default:
          // Handle any other errors 
          const errorKey = Object.keys(FormControl.errors)[0];
          return `${this.translateService.instant('error')} : ${this.translateService.instant(errorKey)}`;
        }
    }
    return null; // No error message
  }

}
